<!-- 通用组件 - 模态框 -->
<template>
    <transition name="fade" v-if="getModalState">
    <div class="modal-box" >
        <div class="context" @click="closeModal"></div>
        <div class="modal" :style="{width:$store.state.msgModal.setModal.width,height:$store.state.msgModal.setModal.height}">
            <span class="modal-close" @click="closeModal">x</span>
            <div class="modal-content">{{$store.state.msgModal.setModal.info}}</div>
        </div>
    </div>
    </transition>
</template>

<script>
    export default {
        data () {
            return {
                title: '消息提示',
                msg: '',
                btnText: '确认'
            }
        },
        mounted () {

        },
        methods: {
            //关闭弹窗
            closeModal () {
                this.$store.commit('showMsgModal', false);
            },
//            //1秒后关闭弹窗
//            setTimeCloseModal () {
//              let totalTime = 1;
//              let timer = setInterval(() => {
//                totalTime--;
//                if(totalTime<=0){
//                  this.$store.commit('showMsgModal', false);
//                  clearInterval(timer);
//                }
//              },1500);
//            }
        },
        computed: {
          getModalState () {
              return this.$store.state.msgModal.showMsgModal
          }
        },
        watch:{
//            '$store.state.msgModal.showMsgModal' () {
//                if(this.$store.state.msgModal.showMsgModal && this.$store.state.msgModal.setModal.autoClose){
//                   this.setTimeCloseModal();
//                }
//            }
        }
    }
</script>

<style scoped>
/*clearfix Start*/
.clearfix:after{
  content:".";
  display:block;
  height:0;
  clear:both;
  visibility:hidden
}
.clearfix{
  *+height:1%;
}

/*transition Start*/
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-active {
  /*transition: 1s;*/
  opacity: 0;
}
/*transition End*/

/*Modal Start*/
.modal-box,
.context
{
  width:100%;
  height:100%;
  position: fixed;
  left:0;
  top:0;
}
.context{
  background-color: #333;
  opacity:0.4;
}
.modal{
  position: absolute;
  min-height: 86px;
  min-width: 295px;
  line-height: 86px;
  left:50%;
  top:40%;
  transform: translate(-50%,-50%);
  background-color: #ffffff;
  border-radius: 8px;
  padding-left:18px;
  padding-right:18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-close{
  color: #b11828;
  cursor:pointer;
  position: absolute;
  padding:2px;
  right: 19px;
  line-height: 16px;
  top: 10px;
}
.modal-content{
   font-size:16px;
   text-align: center;
}
.modal-btn > a{
    display: block;
    width: 35%;
    margin: 0 auto;
    left: 50%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    background-color: #b11828;
    text-align: center;
    text-decoration: none;
    border-radius: 5px;
}
/*Modal End*/
</style>



// WEBPACK FOOTER //
// MsgModal.vue?0a4aff29